import { DEFAULTS } from "./defaults";
import { GALLERY_TYPE } from "./types";
import { nodeViewRenderers } from "./viewer/nodeViewRenderers-loadable";
const pluginGallery = (config) => {
  return {
    config: { ...DEFAULTS.containerData, ...config },
    type: GALLERY_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginGallery
};
//# sourceMappingURL=viewer-loadable.js.map
